import { NeighborhoodsList } from '@/components/neighborhoods';
import { neighborhoodCrudConfig, type Neighborhood } from '@/config/objects/neighborhoods';
import { useApiClient, type CrudConfig } from '@startupquickstart/frontend';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from '@startupquickstart/frontend';

export function GreaterAreaNeighborhoodsTab() {
  const { id } = useParams<{ id: string }>();
  const apiClient = useApiClient();

  const config: CrudConfig<Neighborhood> = useMemo(
    () => ({
      ...neighborhoodCrudConfig,
      entityName: 'Neighborhood',
      entityNamePlural: 'Neighborhoods',
      endpoints: {
        ...neighborhoodCrudConfig.endpoints,
        list: `/greater-areas/${id}/neighborhoods`,
        delete: (neighborhoodId: string) => `/greater-areas/${id}/neighborhoods/${neighborhoodId}`,
      },
      listView: {
        ...neighborhoodCrudConfig.listView,
        actions: {
          add: {
            enabled: true,
            endpoint: '/neighborhoods',
            where: {
              greaterAreaId: {
                not: id,
              },
            },
            onAdd: async (neighborhood: Neighborhood) => {
              await apiClient.post(`/greater-areas/${id}/neighborhoods`, {
                neighborhoodId: neighborhood.id,
              });
              toast.success('Neighborhood added to greater area');
            },
          },
          view: {
            enabled: true,
          },
          remove: {
            enabled: true,
            onRemove: async (neighborhood: Neighborhood) => {
              await apiClient.delete(`/greater-areas/${id}/neighborhoods/${neighborhood.id}`);
              toast.success('Neighborhood removed from greater area');
            },
          },
        },
      },
    }),
    [id, apiClient],
  );

  if (!id) return null;

  return <NeighborhoodsList config={config} className="p-0" baseUrl="/neighborhoods" />;
}
